import { Link } from 'react-router-dom';
import styles from './CollectionTensionBar.module.css';

const RARITY_COLOR = { legendary: '#D4AF37', gold: '#FFD700', silver: '#C0C0C0', bronze: '#CD7F32' };

function getTopRarityColor(items = []) {
    const order = { legendary: 4, gold: 3, silver: 2, bronze: 1 };
    const top = items
        .filter(i => i.verified && i.coinTier)
        .sort((a, b) => (order[b.coinTier] ?? 0) - (order[a.coinTier] ?? 0))[0];
    return RARITY_COLOR[top?.coinTier] ?? '#C8A84B';
}

function CollectionRow({ collection, onClick }) {
    const pct      = collection.total > 0 ? (collection.progress / collection.total) * 100 : 0;
    const nearDone = !collection.completed && collection.remaining <= 2;
    const barColor = getTopRarityColor(collection.items);

    return (
        <button
            className={`${styles.row} ${nearDone ? styles.nearDone : ''} ${collection.completed ? styles.done : ''}`}
            onClick={() => onClick?.(collection.slug)}
            style={{ '--bar': barColor }}
        >
            <div className={styles.rowTop}>
                <span className={styles.name}>{collection.name}</span>
                <span className={styles.count}>{collection.progress}/{collection.total}</span>
            </div>
            <div className={styles.track}>
                <div className={styles.fill} style={{ width: `${pct}%` }} />
            </div>
            {nearDone && (
                <span className={styles.nearDoneHint}>
                    ✦ {collection.remaining === 1 ? '1 film away from Legendary' : `${collection.remaining} more to unlock`}
                </span>
            )}
            {collection.completed && <span className={styles.completedHint}>✓ Complete</span>}
        </button>
    );
}

export default function CollectionTensionBar({ collections = [], loading, onCollectionClick }) {
    if (loading) {
        return (
            <aside className={styles.panel}>
                <h3 className={styles.title}>🏛️ Collections</h3>
                {[1, 2, 3].map(i => <div key={i} className={styles.skeleton} />)}
            </aside>
        );
    }

    const active    = collections.filter(c => !c.completed).slice(0, 5);
    const completed = collections.filter(c => c.completed).slice(0, 2);
    const all       = [...active, ...completed];

    return (
        <aside className={styles.panel}>
            <div className={styles.panelHeader}>
                <h3 className={styles.title}>🏛️ Collections</h3>
                <Link to="/collections" className={styles.viewAll}>View all →</Link>
            </div>
            <div className={styles.list}>
                {all.length === 0 ? (
                    <div className={styles.empty}>
                        <p>No collections started yet.</p>
                        <Link to="/collections">Explore →</Link>
                    </div>
                ) : (
                    all.map(c => (
                        <CollectionRow key={c.id} collection={c} onClick={onCollectionClick} />
                    ))
                )}
            </div>
        </aside>
    );
}